import axios from 'axios';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ItemType from '../types/item';

import './Orders.css';
import { useCurrentUserContext } from '../contexts/CurrentUserContext';

function Orders({ items }) {
  const [orders, setOrders] = useState([]);
  const { currentUser } = useCurrentUserContext();

  useEffect(() => {
    if (currentUser.access === 'associate') {
      const ws = new WebSocket(
        `${
          window.location.protocol === 'https:' ? 'wss://' : 'ws://'
        }${window.location.host}/ws-cafe`,
      );
      ws.onopen = () => {
        console.log('Connected to WebSocket server');
      };
      ws.onerror = (event) => {
        console.error(event);
      };
      ws.onmessage = (message) => {
        const data = JSON.parse(message.data);
        setOrders(data);
      };
      ws.onclose = () => {
        console.log('Disconnected from WebSocket server');
      };
      return () => {
        ws.close();
        setOrders([]);
      };
    }
    return () => {};
  }, [currentUser]);

  const deleteOrder = async (order) => {
    try {
      await axios.delete(`/api/orders/${order.id}`);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div className="orders-component">
      <h2>Existing Orders</h2>
      {orders.length === 0 ? (
        <div>
          {currentUser.access === 'associate' ? 'No orders found.'
            : 'Only associates can view orders.'}
        </div>
      ) : (
        <div>
          {orders.map((order) => (
            <div key={order.orderId} className="order">
              <table>
                <thead>
                  <tr>
                    <th>Customer</th>
                    <th>ZIP Code</th>
                    {order.phone && <th>Phone</th>}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{order.name}</td>
                    <td>{order.zipCode}</td>
                    {order.phone && <td>{order.phone}</td>}
                  </tr>
                </tbody>
                <thead>
                  <tr>
                    <th>Quantity</th>
                    <th>Item</th>
                  </tr>
                </thead>
                <tbody>
                  {order.items.map((item) => (
                    <tr key={item.itemId}>
                      <td>{item.quantity}</td>
                      <td>{items.find((i) => i.itemId === item.itemId)?.title || 'Unknown'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button type="button" onClick={() => deleteOrder(order)}>
                Delete Order
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

Orders.propTypes = {
  items: PropTypes.arrayOf(ItemType).isRequired,
};

export default Orders;
